import { BaseApiService } from '@/services/base-service';
import {
  BaseResponse, Filters,
} from '@/types';
import { default_certs } from '@/components/widgets/services';
import {
  Analytics, Users, Organizations, Categories, OperatioTypes, RepairsTypes, Clients, AnalyticsFilters, CreditLineContract,
} from '../types';

interface AnalyticsList extends BaseResponse {
  data: {
    items: Analytics.Section;
    users: Users[];
    organizations: Organizations[];
    external_organization: string[];
    course_categories: Categories[],
    order_side_operation_types: OperatioTypes[],
    order_side_repair_types: RepairsTypes[],
    lead_regions: string[],
    clients: Clients[],
    order_side_numbers: string[],
    years: string[],
    credit_line_contracts: CreditLineContract[],
  }
}

export class AnalyticsService extends BaseApiService {
  private readonly base_path = 'analytics';

  async get_analytics(): Promise<AnalyticsList> {
    const { data } = await this.http_client.get<AnalyticsList>(this.base_path);

    return data;
  }

  async get_analytics_filters(filters: Filters, section: string): Promise<AnalyticsList> {
    const url = `${this.base_path}/${section}`;
    const payload = filters;

    const { data } = await this.http_client.get<AnalyticsList>(url, {
      params: {
        filters: payload.filters,
      },
    });

    return data;
  }
}

export const default_analytics = (): Analytics.Section => ({
  orders: {
    statuses: { total_count: 0, items: [] },
    payment_statuses: { total_count: 0, items: [] },
  },
  certs: default_certs(),
  returns_zip: { total_count: 0, items: [] },
  order_sides: { total_count: 0, items: [] },
  repair_models: { total_count: 0, items: [] },
  leads: { total_count: 0, items: [] },
  repair_types: { total_count: 0, items: [] },
  result_service_activity: {
    company: '',
    final_score: {
      name: '',
      value: '',
      grade: '',
    },
    quater: 0,
    year: '',
    items: [],
  },
  credit_line: { total_count: 0, items: [] },
});

export const default_filters = (): AnalyticsFilters => ({
  order_user_id: [],
  cert_user_id: [],
  order_organization_id: [],
  order_side_organization_id: [],
  repair_model_organization_id: [],
  repair_types_organization_id: [],
  rsa_organization_id: [],
  order_side_client_id: null,
  repair_model_client_id: null,
  repair_types_client_id: null,
  course_category_id: null,
  course_id: null,
  order_side_operation_type_id: [],
  repair_model_operation_type_id: [],
  repair_type_id: [],
  external_organizations: [],
  region: null,
  order_side_numbers: [],
  order_side_dates: [],
  repair_model_dates: [],
  lead_dates: [],
  repair_types_dates: [],
  date: '',
  quarter: null,
  year: null,
  credit_line_organization_ids: [],
  credit_line_contract_ids: [],
  credit_line_organization_atols: [],
});
